import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import './styles/dashboard-typography.css'; // Tipografia Poppins para dashboards
import './styles/public-typography.css'; // Tipografia Poppins para paginas publicas
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css'; // Importar Bootstrap
import { ThemeProvider } from './context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <Router>
        <App />
      </Router>
    </ThemeProvider>
  </React.StrictMode>
);
